export function buildCrmSidebarItem({ t, accountScopedRoute, pipelines }) {
  return {
    name: 'CRM',
    label: t('SIDEBAR.CRM'),
    icon: 'i-lucide-columns-3',
    activeOn: ['crm_view'],
    children: [
      {
        name: 'CrmKanban',
        label: t('CRM.SIDEBAR.KANBAN'),
        to: accountScopedRoute('crm_view', {}, { view: 'kanban' }),
      },
      {
        name: 'CrmList',
        label: t('CRM.SIDEBAR.LIST'),
        to: accountScopedRoute('crm_view', {}, { view: 'list' }),
      },
      {
        name: 'CrmFunnels',
        label: t('CRM.SIDEBAR.FUNNELS'),
        icon: 'i-lucide-align-justify',
        collapsible: true,
        showTreeLine: true,
        to: accountScopedRoute('crm_view', {}, { view: 'funnels' }),
        children: [
          ...(pipelines || []).map(p => ({
            name: `pipeline-${p.id}`,
            label: p.name,
            to: accountScopedRoute(
              'crm_view',
              {},
              { pipelineId: p.id, view: 'kanban' }
            ),
          })),
        ],
      },
    ],
  };
}
